export default __webpack_public_path__ + "static/media/fast-forward-solid.48bf3bca.svg";